













































import useRootSetting from '@/hooks/useRootSetting'
import {defineComponent, reactive, ref, watch, toRefs} from '@vue/composition-api'

export default defineComponent({
  components: {},
  props: {
    companyInfo: {
      type: Object,
      default: () => {
      }
    },
    allInfo: {
      type: Object,
      default: () => {
      }
    },
    flag: {
      type: Boolean,
      default: false
    }
  },
  setup(props, {emit}) {
    const {getIsMobile} = useRootSetting()
    const defaultForm = () => ({
      dscompany: '',
      dsname: '',
      dsbumen: '',
      dstel: '',
      dsphone: '',
      dsmax: '',
      dsemail: '',
      dsbank:'',
      dsbanknum:'',
      dskpsbnum:'',
    })
    const form = reactive(defaultForm())
    const formRef = ref(null)
    const showContact = ref(false)

    //选完报价公司给公司名赋值
    watch(() => props.companyInfo, (data) => {
      form.dscompany = data.name
    }, {immediate: true, deep: true})

    //清掉公司名，其余信息都被清除
    watch(() => form.dscompany, (val) => {
      if (val === '') Object.assign(form, defaultForm())
    }, {immediate: true, deep: true})

    //清掉接受人，除公司信息其余信息都被清除
    watch(() => form.dsname, (val) => {
      if (val === '') {
        Object.assign(form, {
          ...defaultForm(),
          dscompany: form.dscompany // 保留 dscompany 现有值
        })
      } else {
        emit('handleFlag', false)
      }
    }, {immediate: true, deep: true})
    const reactiveInfo = toRefs(props.allInfo);
    //选完联系人给所有信息赋值
    watch(() => reactiveInfo, (val) => {
      Object.assign(form, val)
    }, {immediate: true, deep: true})

    //展示接收人的联系人弹窗
    const handleContact = () => {
      showContact.value = true
      emit('handleContact', showContact.value)
    }
    return {
      formRef,
      form,
      getIsMobile,
      showContact,
      handleContact
    }
  }
})
